import { Directive } from "vue";

const highlightDirective: Directive = {
    beforeMount(el, binding) {
        const fields = binding.value;
        if (Array.isArray(fields) && fields.length > 0) {
          fields.forEach((field: string) => {
            if (field && el.classList.contains(field)) {
              el.classList.add("highlight");
            }
          });
        }
      },
    
      updated(el, binding) {
        const fields = binding.value;
        if (Array.isArray(fields) && fields.length > 0) {
          fields.forEach((field: string) => {
            if (field && el.classList.contains(field)) {
              el.classList.add("highlight");
            }
          });
        }
      }
};

export default highlightDirective;
